export default class TitleExtension {
	constructor(naja) {
		naja.addEventListener('success', function(e) {
			let title = e.response.title;

			if (title !== undefined) {
				document.title = title;
			}
		});
	}
}